export const PROPERTY_UNITS = "PROPERTY_UNITS";
export const PARKING_UNITS = "PARKING_UNITS";
export const GET_PAYMENT_PLAN = "GET_PAYMENT_PLAN";
export const GET_SINGLE_UNIT = "GET_SINGLE_UNIT";
export const GET_UNIT_SUBTYPE = "GET_UNIT_SUBTYPE";
export const BOOKING_PROPERTY_UNITS = "BOOKING_PROPERTY_UNITS";



